'use strict';

//Fetch module (defined in app.js)
angular.module('App.v1.Services')

	//******************** SERVICES *****************************************************************
	.factory('App.v1.Services.MessageTemplate', ['$resource', '$filter',
		function ($resource, $filter) {
			return $resource(
				'/api/messageTemplate/:id',
				{},
				{
					'list': { method: 'GET', isArray: true },
					'get': { method: 'GET', isArray: false }
				}
			);
		}]);
